import { graphql, useStaticQuery } from 'gatsby';

export const usePortfolioPicture = () => {
	// const image = data.file.childImageSharp.fluid
	const data = useStaticQuery(graphql`
		query {
			file(relativePath: { eq: "portfolio-bg.jpg" }) {
				...ChildImageSharpFluid
			}
		}
	`);
	return data.file.childImageSharp.fluid;
};
